import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function CrudFilters({ fields, filters, handleFilterChange }) {
    return (
        <Box sx={{ mb: 2, display: "flex", gap: 2 }}>
            {fields.filter(f => !f.hiddenCol).map(f => (
                <TextField
                    key={f.name}
                    name={f.name}
                    label={`Filtrar ${f.label}`}
                    value={filters[f.name] || ""}
                    onChange={handleFilterChange}
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                />
            ))}
            <Select
                size="small"
                name="isActive"
                value={filters.isActive === undefined || filters.isActive === "" ? "" : Number(filters.isActive)}
                onChange={e => {
                    // Convert value to number or empty string
                    handleFilterChange({
                        ...e,
                        target: {
                            ...e.target,
                            value: e.target.value === "" ? "" : Number(e.target.value)
                        }
                    });
                }}
                displayEmpty
                sx={{ minWidth: 120 }}
            >
                <MenuItem value="">
                    <em>Todos</em>
                </MenuItem>
                <MenuItem value={1}>Activos</MenuItem>
                <MenuItem value={0}>Inactivos</MenuItem>
            </Select>
        </Box>
    );
}
